import { render, staticRenderFns } from "./StampTakenImage.vue?vue&type=template&id=85b8b532&scoped=true&"
import script from "./StampTakenImage.vue?vue&type=script&lang=js&"
export * from "./StampTakenImage.vue?vue&type=script&lang=js&"
import style0 from "./StampTakenImage.vue?vue&type=style&index=0&id=85b8b532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b8b532",
  null
  
)

export default component.exports